// extracted by mini-css-extract-plugin
export default {"arrowHeadAlt":"MapToggle_arrowHeadAlt__yqANO","arrowAlt":"MapToggle_arrowAlt__FYEVU"};